import './button-toggle.scss';

class ButtonToggle {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-buttontoggle'
        };

        this.settings = Object.assign({}, defaults, options);

        // Root element
        this.$root = element;

        // Properties
        this.controlId = this.$root.getAttribute('aria-controls');

        // Elements
        this.$relatedContent = document.getElementById(this.controlId);
    }

    initialize () {
        this.setEvents();
    }

    changeState (expand) {
        this.$root.setAttribute('aria-expanded', expand);
        this.toggleRelatedContent(expand);
    }

    toggleRelatedContent (expand) {
        if (this.$relatedContent) {
            this.$relatedContent.setAttribute('aria-hidden', !expand);
        }
    }

    setEvents () {
        this.$root.addEventListener('click', () => {
            const isExpanded = this.$root.getAttribute('aria-expanded') === 'true';
            this.changeState(!isExpanded);

            const changeStateEvent = new CustomEvent('buttonToggle.stateChange', {
                detail: { api: this, state: !isExpanded }
            });

            window.dispatchEvent(changeStateEvent);
        });
    }
}

export { ButtonToggle };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-buttontoggle]');
        $$roots.forEach($root => {
            const $rootAPI = new ButtonToggle($root);
            $rootAPI.initialize();
            $root.buttonToggleAPI = $rootAPI;
        });
    }
});
